import { createFileRoute, redirect } from "@tanstack/react-router";
import { brandSubRedirectUrl } from "@/components/inventory/FilterRedirects";
import { pageHead } from "@/lib/routeHead";

// Legacy brand model URL → permanent redirect to the canonical search URL.
// A client-side <Navigate> returned 200 HTML here, which Google indexed as a
// duplicate; a 301 consolidates it instead.
export const Route = createFileRoute("/product-intech-rv/$path")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/product-intech-rv/:path' }),
  beforeLoad: ({ params }) => {
    throw redirect({
      href: brandSubRedirectUrl("product-intech-rv", params.path),
      statusCode: 301,
      throw: true,
    });
  },
});
